export default __webpack_public_path__ + "static/media/banner1.73ac128a.png";